import React from 'react';
import {Button, message, Popconfirm} from "antd";
import {DeleteOutlined} from "@ant-design/icons";
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import {
    useDeleteVehicleByIdMutation,
    useGetVehicleQuery
} from "../../../slices/rootApiSlices/vehicleApiSlice";

const DeleteVehicle = ({id}) => {

    const navigate = useNavigate();
    const {user} = useSelector(state => state.auth);
    const {refetch} = useGetVehicleQuery(user?.token)
    const [deleteHandle, isLoading] = useDeleteVehicleByIdMutation();


    const handleDelete = async () => {
        try {
            await deleteHandle({token: user?.token, id}).unwrap();
            navigate('/settings/vehicles');
            refetch();
            message.success('İşlem başarılı')
        } catch (e) {
            console.log(e)
        }
    }

    const cancel = () => {
        message.warning('İşlemden vazgeçildi.');
    };


    return (
        <Popconfirm
            title="Aracı silmek istediğinize emin misiniz ?"
            onConfirm={handleDelete}
            onCancel={cancel}
            okText="Sil"
            cancelText="Vazgeç"
        >
            <Button loading={isLoading} style={{marginLeft: 3}} type="primary" danger icon={<DeleteOutlined/>}>
                Sil
            </Button>
        </Popconfirm>
    );
};

export default DeleteVehicle;
